<template>
  <div>
    <v-dialog
      :value="dialogEntityShow"
      transition="dialog-bottom-transition"
      fullscreen
      hide-overlay
      :persistent="entityDialogPersistentStatus"
    >
      <v-toolbar 
        dark 
        color="#173862"
      >
        <v-dialog
          v-if="settingsModifyStatus"
          v-model="dialogEntityCloseButton"
          max-width="355px"
          persistent
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon dark>
              <v-icon v-bind="attrs" v-on="on">mdi-close</v-icon>
            </v-btn>
          </template>
          <v-card class="pa-3">
            <v-card-title class="pb-5 conformation_dialog">
              {{ $t('customer.entity.unsavedChanges') }} <br>
              {{ $t('customer.entity.wishSave') }}
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                @click="unsaveSettings"
                color="red darken-1"
                dark
              >{{ $t('cancel') }}</v-btn>
              <v-btn
                @click="saveEntity()"
                color="green darken-1"
                dark
              >{{ $t('save') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-btn 
          v-else
          icon 
          dark 
          @click="entityDialogClose"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <v-toolbar-title class="px-0">{{ $t('customer.entity.fieldSettings') }} - Create Ticket</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn
            @click="dialogEntityConfirm = true"
            color="orange darken-1"
            class="pa-2"
            dark
          >
            {{ $t('save') }}
          </v-btn>
          <ConfirmDialog
            v-if="dialogEntityConfirm"
            :confirmDialogShow="dialogEntityConfirm"
            @confirm-dialog-close="dialogEntityConfirm = false"
            @confirm-dialog-save="saveEntity"
          />

        </v-toolbar-items>
      </v-toolbar>
      <v-card>
        <v-card-text class="pb-0">
          <v-form
            v-model="entityFormValidity"
            @submit.prevent="saveEntity"
            ref="entityForm"
          >
            <v-text-field 
              :label="$t('customer.entity.type')" 
              v-model="currentItem.type"
              :rules="standardFieldRules"
              tabindex="1"
              v-show="false"
            ></v-text-field>
            <v-container class="grey lighten-5 pb-0 inputs-container">
              <v-row>
                <v-col cols="6" class="py-0 px-1 ma-0">
                  <v-text-field 
                    v-model="currentItem.entityLabel"
                    :rules="standardFieldRules"
                    tabindex="2"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pt-0 mt-0">
                  <v-tooltip
                    :open-delay="tooltipDelay"
                    bottom
                  >
                    <template v-slot:activator="{ on }">
                      <span>
                        <v-checkbox
                          :label="$t('customer.entity.linkTranscript')"
                          v-model="currentItem.attachTranscript.link"
                          v-on="on"
                          hide-details
                          class="pl-2"
                          tabindex="3"
                          @click="linkTranscriptToggleChange(currentItem)"
                        ></v-checkbox>
                      </span>
                    </template>
                    <span>
                      {{ $t('customer.entity.zendesk.createTicketAndAttach') }}
                    </span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pt-0 mt-0">
                  <v-radio-group 
                    v-model="currentItem.attachTranscript.commentType" 
                    v-show="currentItem.attachTranscript.link"
                    :label="$t('customer.entity.attachTranscriptAs')" 
                    hide-details
                    class="pl-4 pb-2"
                    row 
                  >
                    <v-radio :label="$t('customer.entity.zendesk.publicComment')" value="public"></v-radio>
                    <v-radio :label="$t('customer.entity.zendesk.privateComment')" value="private"></v-radio>
                    <!-- <v-radio label="Attached as file (.TXT)" value="text"></v-radio> -->
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pa-0 ma-0">
                  <v-data-table
                    :headers="headers"
                    :items="fieldItems"
                    hide-default-footer
                    class="elevation-1">
                      <template v-slot:top>
                        <v-toolbar flat color="white">
                          <v-toolbar-title>
                            {{ $t('customer.entity.formFields') }} 
                            <span style="font-size: 12px; color: grey;">
                              ({{ $t('customer.entity.zendesk.fieldsForTicket') }})
                            </span>
                          </v-toolbar-title>
                          <v-divider
                            class="mx-4"
                            inset
                            vertical
                          ></v-divider>
                          <!-- <span>
                            Used <b>{{ fieldItems.length }}</b> field(s) out of <b>{{ maximumFieldListLength }}</b>. You can add <b>{{ maximumFieldListLength-fieldItems.length }}</b> more fields to this entity.
                          </span> -->
                          <v-spacer></v-spacer>
                          <v-tooltip
                            :open-delay="tooltipDelay"
                            top
                          >
                            <template v-slot:activator="{ on }">
                              <span>
                                <v-btn
                                  :disabled="checkFieldListLength"
                                  color="primary"
                                  v-on="on"
                                  dark
                                  class="mb-2"
                                  @click="openDialogField"
                                >
                                  <v-icon left>mdi-plus</v-icon>{{ $t('customer.entity.newField') }}
                                </v-btn>
                              </span>
                            </template>
                            <span>
                              {{ $t('customer.entity.zendesk.ticketNewFieldTooltip') }}
                            </span>
                          </v-tooltip>
                        </v-toolbar>
                      </template>
                      <template v-slot:item.customField="{ item }">
                        {{ item.customField ? $t('customer.entity.custom') : $t('customer.entity.standard') }}
                      </template>
                      <template v-slot:item.actions="{ item }">
                        <div id="block_container">
                          <!-- Edit field action button -->
                          <v-tooltip
                            :open-delay="tooltipDelay"
                            top
                          >
                            <template v-slot:activator="{ on }">
                              <div v-on="on" id="bloc1">
                                <v-icon
                                  v-on="on"
                                  small
                                  class="mr-2"
                                  @click="editItem(item)"
                                >
                                  mdi-pencil
                                </v-icon>
                              </div>
                            </template>
                            <span>
                              {{ $t('customer.entity.editFieldTooltip') }}
                            </span>
                          </v-tooltip>
                          <!-- Delete field action button -->
                          <v-tooltip
                            :open-delay="tooltipDelay"
                            top
                          >
                            <template v-slot:activator="{ on }">
                              <div v-on="on" id="bloc2">
                                <v-icon
                                  v-on="on"
                                  small
                                  @click="deleteItemConfirm(item)"
                                  :disabled="(item.default && item.required) ? true : false "
                                >
                                  mdi-delete
                                </v-icon> 
                              </div>
                            </template>
                            <span>
                              {{  (item.default && item.required) ? $t('customer.entity.disableDeleteFieldTooltip') : $t('customer.entity.deleteFieldTooltip')  }}
                            </span>
                          </v-tooltip>
                        </div>
                      </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MODALS / DIALOGS START -->

    <!-- Dialog Delete Field Confirmation - Start -->
    <v-dialog
      v-model="dialogEntityDelete"
      max-width="290px"
      persistent
    >
      <v-card class="pa-3">
        <v-card-title class="pb-5 conformation_dialog">{{ $t('customer.entity.wantToDelete') }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="dialogEntityDeleteCancel()"
            color="red darken-1"
            dark
          >{{ $t('cancel') }}</v-btn>
          <v-btn
            @click="deleteItem()"
            color="green darken-1"
            dark
          >{{ $t('delete') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog Delete Field Confirmation - End -->

    <!-- Dialog Add / Edit Field  -->
    <ZendeskFieldFormTicket 
      v-if="fieldDialogShow"
      :fieldDialogShow="fieldDialogShow"
      :fieldData="newField"
      @field-dialog-close="fieldFormClose"
      @field-save="fieldSave"
    />

  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import filtersMixin from '@/mixins/filtersMixins'
  import i18n from '../i18n';
  import { customerMixin } from '../mixins/customerMixins'

  export default {
    props: {
      dialogEntityShow: {
        required: true,
        type: Boolean
      },
      entityData: {
        required: true,
        type: Object
      },
      entityIndex: {
        required: false,
        type: Number
      },
    },
    components: {
      ZendeskFieldFormTicket: () => import('@/components/ZendeskFieldFormTicket'),
      ConfirmDialog: () => import('@/components/ConfirmDialog')
    },
    mixins: [filtersMixin, customerMixin],
    created () {
      console.log(`[ZendeskCreateTicketDialog] - created...`);
      // console.log(`[ZendeskCreateTicketDialog] - created - this.dialogEntityShow:`, this.dialogEntityShow);
      // console.log(`[ZendeskCreateTicketDialog] - created - this.entityData:`, this.entityData);
      // console.log(`[ZendeskCreateTicketDialog] - created - this.entityIndex:`, this.entityIndex);
      
      // set the currentItem with the entity data
      this.currentItem = { ...this.entityData }
      // console.log(`[ZendeskCreateTicketDialog] - created - this.currentItem: `, this.currentItem);
    
      // set the currentItem with the entity data
      this.currentItemIndex = this.entityIndex
      // console.log(`[ZendeskCreateTicketDialog] - created - this.currentItemIndex: `, this.currentItemIndex);
    
      this.fieldItems = [...this.currentItem.formInfo];

      // get Customer Profile data 
      const customerProfile = this.$store.getters['users/getCustomerProfile'];
      // console.log(`[ZendeskCreateTicketDialog] - created - customerProfile: `, customerProfile);

      // populate the customerProfile with the values from login response
      this.customerProfile = { ...customerProfile }

    },
    mounted() {
      this.settingsModifyWatcher()
    },
    data() {
      return {
        customerProfile: {},
        currentItem: {},
        currentItemIndex: null,
        fieldItems: [],
        fieldDialogShow: false,
        editedIndex: -1,
        headers: [
          { text: i18n.t('customer.fieldForm.fieldId'), value: 'fieldId' },
          { text: i18n.t('customer.fieldForm.fieldName'), value: 'fieldName' },
          { text: i18n.t('customer.fieldForm.label'), value: 'label' },
          { text: i18n.t('customer.fieldForm.fieldType'), value: 'customField' },
          { text: i18n.t('customer.fieldForm.dataType'), value: 'dataType' },
          { text: i18n.t('customer.fieldForm.required'), value: 'required' },
          { text: i18n.t('customer.entity.actions'), value: 'actions', sortable: false },  
        ],
        settingsModifyStatus: false,
        dialogEntityConfirm: false,
        dialogEntityDelete: false,
        dialogEntityCloseButton: false,
        entityFormValidity: false,
        standardFieldRules: [
          value => !!value || i18n.t('validation.field.isRequired'),
        ],
        resolve: null,
        reject: null,
        newField: {},
        defaultField: {},
        fieldIndexToDelete: null,
        // maximum item list length per Entity
        maximumFieldListLength: 10
      }
    },
    computed: {
      ...mapGetters({
        tooltipDelay: 'users/getTooltipDelay'
      }),
      checkFieldListLength(){
        return (this.fieldItems.length >= this.maximumFieldListLength) ? true : false
      }
    },
    methods: {
      deleteItemConfirm (field) {
        const index = this.fieldItems.indexOf(field)
        this.fieldIndexToDelete = index

        this.dialogEntityDelete = true
      },
      dialogEntityDeleteCancel () {
        this.dialogEntityDelete = false
        this.fieldIndexToDelete = null
      },
      settingsModifyWatcher () {
        // this.$watch('items',{
        this.$watch('currentItem', {
          handler: function (val, oldVal) {
            // console.log('watch:', 'newval: ', val, '   oldVal:', oldVal)
            
            if (oldVal.type && val.type) {
              // console.log('settingsModifyWatcher - watch - currentItem:', 'newval: ', val, '   oldVal:', oldVal)
              this.settingsModifyStatus = true;
            }
          },
          deep: true
        });

       this.$watch('fieldItems', { 
          handler: function (val, oldVal) {
            // console.log('settingsModifyWatcher - watch - fieldItems:', 'newval: ', val, '   oldVal:', oldVal)
            
            if (oldVal.type && val.type) {
              // console.log('settingsModifyWatcher - watch - IF - fieldItems:', 'newval: ', val, '   oldVal:', oldVal)
              this.settingsModifyStatus = true;
            }
          },
          deep: true
        }); 
      },
      unsaveSettings() {
        // reset the variables
        this.settingsModifyStatus = false;
        this.dialogEntityCloseButton = false;

        this.currentItem = {};
        this.fieldItems = []

        this.$emit('entity-dialog-close')

      },
      resetEntityForm () {
        this.$refs.entityForm.reset()
      },
      openDialogField(){
        this.fieldDialogShow = true
      },
      entityDialogClose() {
        this.$emit('entity-dialog-close')
      },
      editItem (item) {
        this.editedIndex = this.fieldItems.indexOf(item)
        // this.newField = { ...item }
        this.newField = JSON.parse(JSON.stringify(item))
        // console.log('XXXCustomerWidgetConfig - editItem - item: ', item);
        // console.log('XXXCustomerWidgetConfig - editItem - this.editedIndex: ', this.editedIndex);
        // console.log('XXXCustomerWidgetConfig - editItem - this.newField: ', this.newField);

        this.fieldDialogShow = true;
      },
      deleteItem () {
        const index = this.fieldIndexToDelete
        this.fieldItems.splice(index, 1)
        // reset to original value
        this.fieldIndexToDelete = null
        // close the Dialog
        this.dialogEntityDelete = false;
        // set to true when any change happens
        this.settingsModifyStatus = true;
      },
      fieldFormClose() {
        this.fieldDialogShow = false

        this.$nextTick(() => {
          // this.newField = Object.assign({}, this.defaultField);
          this.newField = { ...this.defaultField };
          this.editedIndex = -1;
        })
      },
      fieldSave(fieldData) {
        // console.log('[ZendeskCreateTicketDialog] - fieldSave -  fieldData: ', fieldData);
        
        // reset the field object values
        // this.newField = { ...this.defaultField };
        
        // clean field before use it
        this.newField = JSON.parse(JSON.stringify(this.defaultField));

        // copy the values to newField 
        this.newField = JSON.parse(JSON.stringify(fieldData));
        // console.log('[ZendeskCreateTicketDialog] - fieldSave -  this.newField: ', this.newField);
        // console.log('[ZendeskCreateTicketDialog] - fieldSave -  this.editedIndex: ', this.editedIndex);
        // console.log('[ZendeskCreateTicketDialog] - fieldSave -  this.fieldItems 0: ', JSON.stringify(this.fieldItems));
        
        // edit
        if (this.editedIndex > -1) {
          // reset the object
          // Object.assign(this.fieldItems[this.editedIndex], {})
          this.fieldItems[this.editedIndex] = {}
          // console.log('[ZendeskCreateTicketDialog] - fieldSave -  this.fieldItems 1: ', JSON.stringify(this.fieldItems));
          Object.assign(this.fieldItems[this.editedIndex], this.newField)
          // update the data to update Datatable content
          this.fieldItems = [ ... this.fieldItems ]

        } else {
          // when add a new field
          this.fieldItems.push(this.newField)
        }
        // console.log('[ZendeskCreateTicketDialog] - fieldSave -  this.fieldItems 2: ', JSON.stringify(this.fieldItems));

        this.settingsModifyStatus = true;
        this.fieldFormClose()
      },
      saveEntity() {
        // console.log(`[ZendeskCreateTicketDialog] - saveEntity - this.currentItem:`, this.currentItem);
        // console.log(`[ZendeskCreateTicketDialog] - saveEntity - this.currentItemIndex:` , this.currentItemIndex);
        // console.log(`[ZendeskCreateTicketDialog] - saveEntity - this.customerProfile:`, this.customerProfile);

        const attachTypes = ['public', 'private']
        // const attachAs = (this.currentItem.attachTranscript.commentType == 'public' 
        //                   || this.currentItem.attachTranscript.commentType == 'private' )
        //                   ? 'comment'
        //                   : 'file'
        const attachAs = attachTypes.includes(this.currentItem.attachTranscript.commentType)
                          ? 'comment'
                          : 'file'

        const entityData = {
          type: this.currentItem.type,
          entityLabel: this.currentItem.entityLabel,
          disable: this.currentItem.disable,
          formInfo: this.fieldItems,
          attachTranscript: {
            link: this.currentItem.attachTranscript.link,
            attachAs: attachAs,
            commentType: this.currentItem.attachTranscript.commentType
          }
        }
        // console.log(`[ZendeskCreateTicketDialog] - saveEntity - entityData: `, entityData);

        this.dialogEntityConfirm = false

        this.$emit('save-entity', entityData)
      },
      async linkTranscriptToggleChange(currentItem) {
        if (currentItem.attachTranscript.link) {
          const accountInfo = { 
            accountId: this.customerProfile.accountId,
            operation: 'linktranscript', 
            platform: this.customerProfile.platform
          }

          await this.verifyAccountID(accountInfo);

          if (!this.accountIdValidationInfo.status) {
            currentItem.attachTranscript.link = false;
            this.showSnack(this.accountIdValidationInfo.message, true);
            this.entityDialogPersistentStatus = true;
          }
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
#block_container
{
  text-align:left;
}
#bloc1, #bloc2
{
  display:inline;
}
</style>